import React, { useState } from 'react'
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import {ImageBuffer} from '../';

import './copyText.css'
import { copy } from '../../assets';

const CopyText = ({text}: any) => {
    const [copiedId, setCopiedId] = useState<string | null>(null);

    const handleCopyId = (value: string) => {
        navigator.clipboard.writeText(value);
        setCopiedId(value);

        setTimeout(() => setCopiedId(null), 2000);
    };

  return (
    <>
        <span className={`copy-text-details ${copiedId === text ? "active" : ""}`}>
          <p><span onClick={() => handleCopyId(text)}><ImageBuffer src={copy} alt='copy' /> Email:</span>{text} 
          {copiedId === text && (
            <>
              <span> Copied!</span>
            </>
          )}
          </p>
        </span>
    </>
  )
}

export default CopyText